import React from "react";

import { useTranslation } from "react-i18next";

import { Price } from "../Atoms";
import { useSession } from "../Session/SessionContext";
import { useVenue } from "../VenueContext";
import { getVenueHasMobileOrdering } from "../venueSelectors";
import { PendingCartItem } from "./PendingCartItem";
import { getCartTotal } from "./selectors";

export const CartItems = ({
  soldOutItemsUuids = [],
}: {
  soldOutItemsUuids?: string[];
}) => {
  const { cart } = useSession();
  const orderingEnabled = getVenueHasMobileOrdering(useVenue());
  const { t } = useTranslation();
  return (
    <div className="space-y-12 ">
      <h3 className="text-2xl font-bold text-center ">
        {orderingEnabled ? t("cart.yourOrder") : t("cart.yourWishlist")}
      </h3>
      {cart.items.length > 0 ? (
        cart.items.map((cartItem) => (
          <PendingCartItem
            key={cartItem.id}
            cartItem={cartItem}
            inSoldOutError={soldOutItemsUuids.includes(cartItem.itemId)}
          />
        ))
      ) : (
        <div className="text-center text-lg font-medium py-24">
          {t("cart.noPendingOrders")}
        </div>
      )}
    </div>
  );
};
